import { graphql } from 'gatsby';
import React from 'react';
import slugify from 'slugify';
import Seo from '../../components/SEO';
import Cover, {
  CoverHeading,
  CoverLead,
  CoverMip,
  CoverPrice,
  coverThemes,
} from '../../components/Cover/Cover';
import HeaderTheme from '../../components/Header/HeaderTheme';
import PageBuilder from '../../components/PageBuilder/PageBuilder';
import Navbar from '../../components/UI/Navbar/Navbar';
import Teaser from '../../components/UI/Teaser/Teaser';

const DefaultTemplate = ({
  data: {
    page: { template: { cover, navbar }, blocks, metadata, seo },
  },
}) => {
  const hasReversedHeader = 
    (cover.theme && coverThemes[ cover.theme ] !== coverThemes.TAN) ||
    !!cover.image;

  const navigation = blocks.pagebuilder
    ?.filter(({ ...item }) => item.showInNavbar)
    .map(({ ...item }) => ({
      label: item.navbarLabel,
      path: `#${slugify(item.navbarLabel, { lower: true })}`,
    }));

  return (
    <>
      <HeaderTheme isReverse={hasReversedHeader}/>

      <Seo 
        description={metadata.metaDescription || cover.lead} 
        image={ metadata.metaImage }
        seo={seo}
      />

      <Cover image={cover.image} theme={coverThemes[ cover.theme ]} hasSpacer>
        {cover.showInPartnershipWithMip && 
          <CoverMip/>
        }

        {cover.teaser && <Teaser>{cover.teaser}</Teaser>}
        {cover.heading && <CoverHeading>{cover.heading}</CoverHeading>}
        {cover.lead && <CoverLead>{cover.lead}</CoverLead>}
        {cover.price && <CoverPrice>{cover.price}</CoverPrice>}
      </Cover>

      {!!navigation?.length && (
        <Navbar
          nodes={navigation}
          customButton={navbar.customButton}
          showReferral={navbar.buttons?.includes('refer')}
          showContact={navbar.buttons?.includes('contact')}
          showBook={navbar.buttons?.includes('book')}
          showCustom={navbar.buttons?.includes('custom')}
        />
      )}

      <PageBuilder blocks={blocks.pagebuilder} />
    </>
  );
};

export const query = graphql`
  query defaultpage($id: String!) {
    page: wpPage(id: { eq: $id }) {
      ...Metadata
      blocks {
        ...PageBuilder
      }
      template {
        ...Cover
        ... on WpDefaultTemplate {
          navbar {
            buttons
            customButton {
              label
              link
            }
          }
        }
      }
    }
  }
`;

export default DefaultTemplate;
